<template>
    <div class="fs16 flex color_333 aic bg_fff ml15 mr15 pt10 pb10 bb relative">
        <div v-for="(data,index) in list" :key="index" class="flex flex0 aic pr5" @click="href(data.page)"
             :class="{'hover':(data.page && $route.path != data.page)}">
            <span class="iconfont icon-fanhui-copy mr5 fs12" v-if="index>0"></span>
            <span class="pointer">{{data.name}}</span>
        </div>
        <slot></slot>
        <slot name="append"></slot>
    </div>
</template>
<script>
  const PAGES = {
      '远程会诊': '/main/consultation/launch',
      '门诊转诊': '/main/referral/outpatient/launch',
      '住院转诊': '/main/referral/hospitalization/launch',
      '检查转诊': '/main/referral/hos/check/launch',
      '日间手术转诊': '/main/referral/hos/surgery/launch'
  };

  export default {
    name: "breadcrumb",
    props: {
      pages: Array,
    },
    data() {
      return {
        data: [
          {name: '首页', page: '/'},
        ]
      }
    },
    computed: {
      list() {
        return this.data.concat(this.pages.map(r => {
          return {name: r, page: PAGES[r]};
        }));
      }
    },
      methods:{
          href(url){
              if(url){
                  this.$router.push(url)
              }
          }
      }
  }
</script>

<style lang="scss" scoped>
 .hover{
     &:hover{
        color:#0893FF;
     }
 }
</style>
